
let interval;

const TORCH_LIFT = `
▗▄▄▄▖▗▄▖ ▗▄▄▖  ▗▄▄▖▗▖ ▗▖    ▗▖   ▗▄▄▄▖▗▄▄▄▖▗▄▄▄▖
  █ ▐▌ ▐▌▐▌ ▐▌▐▌   ▐▌ ▐▌    ▐▌     █  ▐▌     █
  █ ▐▌ ▐▌▐▛▀▚▖▐▌   ▐▛▀▜▌    ▐▌     █  ▐▛▀▀▘  █
  █ ▝▚▄▞▘▐▌ ▐▌▝▚▄▄▖▐▌ ▐▌    ▐▙▄▄▖▗▄█▄▖▐▌     █
`

const message = `
Hello hackers. 👀

If you're reading this, you must be pretty clever...
But remember: real talent is built, not stolen! 🚀

P.S. The only thing you'll find here is encouragement to learn the right way.
Try Ctrl+W for a surprise! (CMD+W on Mac) 😉

Have a great day! 😎
`;

function updateConsole() {
  console.clear();
  console.log(TORCH_LIFT);
  console.log("%c" + message, "font-size: 16px; line-height:1.5;");
}

const isLocalhost = ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname);

if (!isLocalhost) {
  document.addEventListener("turbo:load", () => {
    if (window.exam_session_answer_form) {
      updateConsole();
      interval = setInterval(updateConsole, 500);
    } else {
      clearInterval(interval);
    }
  });
}
